import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { InvoiceHire } from '../../types';
import Input from './Input';
import TextArea from './TextArea';

interface InvoiceHireSignaturesSectionProps {
  register: UseFormRegister<InvoiceHire>;
  errors: FieldErrors<InvoiceHire>;
  isDebitOrCredit: boolean;
}

const InvoiceHireSignaturesSection: React.FC<InvoiceHireSignaturesSectionProps> = ({
  register,
  errors,
  isDebitOrCredit,
}) => {
  return (
    <>
      {/* Signatures Section */}
      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-gray-900">Signatures</h2>
        </div>
        <div className="card-body">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-sm font-medium text-gray-700">Finance Dep.</h3>
              <div>
                <Input
                  label="Name"
                  {...register('financeManager.name', { required: 'Finance manager name is required' })}
                  error={errors.financeManager?.name?.message}
                />
              </div>
              <div>
                <Input
                  label="Signature"
                  {...register('financeManager.signature')}
                  placeholder="Digital signature or initials"
                />
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-sm font-medium text-gray-700">General Manager</h3>
              <div>
                <Input
                  label="Name"
                  {...register('generalManager.name', { required: 'General manager name is required' })}
                  error={errors.generalManager?.name?.message}
                />
              </div>
              <div>
                <Input
                  label="Signature"
                  {...register('generalManager.signature')}
                  placeholder="Digital signature or initials"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Information */}
      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-gray-900">Additional Information</h2>
        </div>
        <div className="card-body">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {!isDebitOrCredit && (
              <div>
                <Input
                  label="Exchange Rate"
                  type="number"
                  step="0.0001"
                  min="0"
                  {...register('exchangeRate', { 
                    min: { value: 0, message: 'Exchange rate must be positive' }
                  })}
                  placeholder="Exchange rate (if applicable)"
                />
              </div>
            )}
            <div className={isDebitOrCredit ? 'md:col-span-2' : 'md:col-span-2'}>
              <TextArea
                label="Notes"
                {...register('notes')}
                rows={3}
                placeholder="Additional notes or special instructions..."
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceHireSignaturesSection;
